"use strict";
/**
 * Created by cuppi on 2017/9/4.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const JToolUrl_1 = require("../tool/JToolUrl");
class NetworkDelegate {
}
exports.default = NetworkDelegate;
exports.defaultInterceptor = {
    requestInterceptor: (config) => {
        // Do something before request is sent
        console.log('POST ' + JToolUrl_1.default.urlFromPortion(config.url, '', config.params));
        return config;
    },
    requestInterceptorError: (error) => {
        // Do something with request error
        return Promise.reject(error);
    },
    responseInterceptor: (response) => {
        // Do something with response data
        return response;
    },
    responseInterceptorError: (error) => {
        // Do something with response error
        return Promise.reject(error);
    },
    resolveInterceptor: (response, data) => {
        return true;
    },
    rejectInterceptor: (response, error) => {
        return true;
    }
};
